<template>
  <div class="logo-carousel">
    <div ref="logo-carousel" class="swiper logo-carousel__wrapper">
        <div class="swiper-wrapper logo-carousel__track">
          <slot></slot>
        </div>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
    </div>
  </div>
</template>

<style lang="scss">
    @import "../../../scss/utils/variables";

    @import "../../../scss/components/_logo-carousel.scss";
</style>

<script>
import Swiper, { Navigation, Autoplay } from 'swiper';

export default {
  data: () => ({
    carousel: null,
    carouselOptions: {
      modules: [Navigation, Autoplay],
      slideClass: "swiper-wrapper > *",
      slidesPerView: 2,
      watchOverflow: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      autoplay: {
        delay: 4000,
      },
      spaceBetween: 20
    },
    perViewBreakpointMap: {
      2: {
        1024: {
          slidesPerView: 2
        }
      },
      5: {
        576: {
          slidesPerView: 2
        },
        768: {
          slidesPerView: 3
        },
        992: {
          slidesPerView: 4
        },
        1200: {
          slidesPerView: 5
        },
      }
    }
  }),
  props: {
    slidesPerView: {
      type: Number,
      default: 1
    }
  },
  methods: {
    async initCarousel() {
      this.carouselOptions.breakpoints =
        this.perViewBreakpointMap[this.slidesPerView] || {};
        
        this.carousel = new Swiper(
            this.$refs["logo-carousel"],
            this.carouselOptions
        );  
    }
  },
  mounted() {
    this.initCarousel();
  }
};
</script>